/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Order_Events_By_TimeInputs */

const en_shortcut_keys_desc_order_events_by_time = /** @type {(inputs: Shortcut_Keys_Desc_Order_Events_By_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sort the Event List by start time.`)
};

const fr_shortcut_keys_desc_order_events_by_time = /** @type {(inputs: Shortcut_Keys_Desc_Order_Events_By_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trier la liste des evenements par temps de debut.`)
};

const de_shortcut_keys_desc_order_events_by_time = /** @type {(inputs: Shortcut_Keys_Desc_Order_Events_By_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sortiere die Ereignisliste nach Startzeit.`)
};

const it_shortcut_keys_desc_order_events_by_time = /** @type {(inputs: Shortcut_Keys_Desc_Order_Events_By_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordina l'elenco degli eventi in base all'ora di inizio.`)
};

const ru_shortcut_keys_desc_order_events_by_time = /** @type {(inputs: Shortcut_Keys_Desc_Order_Events_By_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отсортируйте список событий по времени начала.`)
};

const es_shortcut_keys_desc_order_events_by_time = /** @type {(inputs: Shortcut_Keys_Desc_Order_Events_By_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordenar la lista de eventos por hora de inicio.`)
};

const zh_cn2_shortcut_keys_desc_order_events_by_time = /** @type {(inputs: Shortcut_Keys_Desc_Order_Events_By_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按开始时间对事件列表进行排序。`)
};

const ja_shortcut_keys_desc_order_events_by_time = /** @type {(inputs: Shortcut_Keys_Desc_Order_Events_By_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベント リストを開始時間で並べ替えます。`)
};

const hi_shortcut_keys_desc_order_events_by_time = /** @type {(inputs: Shortcut_Keys_Desc_Order_Events_By_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट लिस्ट को प्रारंभ समय के अनुसार क्रमबद्ध करें।`)
};

const pt_pt2_shortcut_keys_desc_order_events_by_time = /** @type {(inputs: Shortcut_Keys_Desc_Order_Events_By_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordene a lista de eventos por horário de início.`)
};

/**
* | output |
* | --- |
* | "Sort the Event List by start time." |
*
* @param {Shortcut_Keys_Desc_Order_Events_By_TimeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_order_events_by_time = /** @type {((inputs?: Shortcut_Keys_Desc_Order_Events_By_TimeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Order_Events_By_TimeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_desc_order_events_by_time(inputs)
	if (locale === "de") return de_shortcut_keys_desc_order_events_by_time(inputs)
	if (locale === "it") return it_shortcut_keys_desc_order_events_by_time(inputs)
	if (locale === "ru") return ru_shortcut_keys_desc_order_events_by_time(inputs)
	if (locale === "es") return es_shortcut_keys_desc_order_events_by_time(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_desc_order_events_by_time(inputs)
	if (locale === "ja") return ja_shortcut_keys_desc_order_events_by_time(inputs)
	if (locale === "hi") return hi_shortcut_keys_desc_order_events_by_time(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_desc_order_events_by_time(inputs)
	return en_shortcut_keys_desc_order_events_by_time(inputs)
});